import { useEffect, useRef } from "react";
import { sendMessageHistoryRequest } from "../websocket/webSocketRequests";
import { CHAT_WS_RECONNECTED_EVENT, getChatSocket } from "../websocket/webSocketConnection";

const RECONNECT_LIMIT = 20;

export function useRequestMessageHistory(
  roomId,
  isActive,
  { setMessages, setNextCursor, setHasMore, mergeReconnectRoomIdRef }
) {
  // 현재 메시지 중 가장 큰 messageSeq를 추적 — reconnect 시 delta sync용
  const maxSeqRef = useRef(0);

  // messages가 바뀔 때 maxSeq 갱신
  useEffect(() => {
    // setMessages를 통해 최신 메시지를 가져옴
    setMessages((prev) => {
      let max = 0;
      for (const m of prev) {
        if (typeof m.messageSeq === "number" && m.messageSeq > max) max = m.messageSeq;
      }
      maxSeqRef.current = max;
      return prev; // 변경 없음
    });
  });

  useEffect(() => {
    if (!isActive || !roomId) return;
    maxSeqRef.current = 0;
    setMessages([]);
    setNextCursor(null);
    setHasMore(false);
    let timeoutId;
    const socket = getChatSocket();
    if (socket) {
      sendMessageHistoryRequest(socket, roomId, undefined, RECONNECT_LIMIT);
    } else {
      window.connectChatWebSocket?.();
      timeoutId = setTimeout(() => {
        const s = getChatSocket();
        if (s) sendMessageHistoryRequest(s, roomId, undefined, RECONNECT_LIMIT);
      }, 1500);
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [roomId, isActive, setMessages, setNextCursor, setHasMore]);

  useEffect(() => {
    if (!isActive || !roomId) return;
    const onReconnected = () => {
      const s = getChatSocket();
      if (!s) return;

      const lastSeq = maxSeqRef.current;
      if (lastSeq > 0) {
        // delta sync: 마지막 seq 이후 메시지만 요청
        if (mergeReconnectRoomIdRef) mergeReconnectRoomIdRef.current = roomId;
        sendMessageHistoryRequest(s, roomId, undefined, RECONNECT_LIMIT + 1, lastSeq);
      }
      // 메시지가 없었으면 아무것도 안 함
    };
    window.addEventListener(CHAT_WS_RECONNECTED_EVENT, onReconnected);
    return () => window.removeEventListener(CHAT_WS_RECONNECTED_EVENT, onReconnected);
  }, [roomId, isActive, setMessages, setNextCursor, setHasMore]);
}
